export default __webpack_public_path__ + "static/Disposable-Jump-Box-2023-96dac916bca747ff826ee09a3d2d6099.pdf";